import { render, staticRenderFns } from "./ForceReadYiLianKKAuthYiLianDBFWContract.vue?vue&type=template&id=701b4831&scoped=true"
import script from "./ForceReadYiLianKKAuthYiLianDBFWContract.vue?vue&type=script&lang=js"
export * from "./ForceReadYiLianKKAuthYiLianDBFWContract.vue?vue&type=script&lang=js"
import style0 from "./ForceReadYiLianKKAuthYiLianDBFWContract.vue?vue&type=style&index=0&id=701b4831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b4831",
  null
  
)

export default component.exports